import { render, staticRenderFns } from "./FiltersPanel.vue?vue&type=template&id=63e94c60&scoped=true"
import script from "./FiltersPanel.vue?vue&type=script&lang=ts"
export * from "./FiltersPanel.vue?vue&type=script&lang=ts"
import style0 from "./FiltersPanel.vue?vue&type=style&index=0&id=63e94c60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e94c60",
  null
  
)

export default component.exports